// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../generic-components/Icon';
import {
  AndroidStore, AppleStore, LiliLogo, LiliPhone,
} from '../../assets/svg';
import { GO_TO_APP_STYLES, STORES_URLS, TEXTS } from './constants';
import { useStore } from '../../store';
import { isUserUsePhoneDevice } from '../../helpers/deviceType.helper';
import { AUTOMATION_TEST_ID } from '../../constants/general';
import { CustomerProfile } from '../../components/CustomerProfile/CustomerProfile';

interface IProps {
  customTitle?: string;
  customSubTitle?: string;
}

const GoToApp = ({ customSubTitle, customTitle }: IProps) => {
  const isUserLoggedIn = useStore(state => state.currUser().customerId);
  const userData = useStore(state => state.getSummaryData());
  const { customer, accounts } = userData || {};
  const { t } = useTranslation();

  return (
    <div className={`${GO_TO_APP_STYLES.WRAPPER}`} data-testid={`${AUTOMATION_TEST_ID}__go-mobile-app-page`}>
      {(isUserLoggedIn && customer && accounts) && <CustomerProfile />}
      <div className={GO_TO_APP_STYLES.CONTAINER}>
        <div className={`${GO_TO_APP_STYLES.CONTENT_CONTAINER} ${isUserUsePhoneDevice() || !isUserLoggedIn ? '' : 'justify-center'}`}>
          <Icon src={LiliLogo} className={GO_TO_APP_STYLES.LILI_LOGO} />
          <Icon src={LiliPhone} className={GO_TO_APP_STYLES.PHONE_ICON} />
          <div className={GO_TO_APP_STYLES.TEXT_CONTAINER}>
            <h1 className={GO_TO_APP_STYLES.TEXT_1} data-testid={`${AUTOMATION_TEST_ID}__go-mobile-app-page__title`}>{t(customTitle || TEXTS.TEXT_1)}</h1>
            <h3 className={GO_TO_APP_STYLES.TEXT_2} data-testid={`${AUTOMATION_TEST_ID}__go-mobile-app-page__subtitle`}>{t(customSubTitle || '')}</h3>
          </div>
          {(isUserUsePhoneDevice() || !isUserLoggedIn) && (
          <div className={GO_TO_APP_STYLES.STORES_CONTAINER}>
            <Icon
              className={GO_TO_APP_STYLES.STORE_ICON}
              src={AppleStore}
              onClick={() => window.open(STORES_URLS, '_blank')}
            />
            <Icon
              className={GO_TO_APP_STYLES.STORE_ICON}
              src={AndroidStore}
              onClick={() => window.open(STORES_URLS, '_blank')}
            />
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoToApp;
